import type { IconProps } from './base';
import { BaseIcon } from './base';

export function IconFlagDK(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <mask id="icon-flag-dk" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
        <circle cx="12" cy="12" r="12" fill="#fff" />
      </mask>
      <g mask="url(#icon-flag-dk)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 2a2 2 0 0 1 2-2h20a2 2 0 0 1 2 2v20a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2Z"
          fill="#C8102E"
        />
        <path
          d="M2 .5h20A1.5 1.5 0 0 1 23.5 2v20a1.5 1.5 0 0 1-1.5 1.5H2A1.5 1.5 0 0 1 .5 22V2A1.5 1.5 0 0 1 2 .5Z"
          stroke="#3C3C64"
          strokeOpacity={0.1}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10 10V0h4v10h10v4H14v10h-4V14H0v-4h10Z"
          fill="#fff"
        />
        <circle cx={12} cy={12} r={11.5} stroke="#3C3C60" strokeOpacity={0.1} />
      </g>
    </BaseIcon>
  );
}
